import { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Snackbar,
  Alert,
  Avatar,
  Divider,
  CircularProgress
} from "@mui/material";
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import axiosInstance from '../../helpers/axios'
import deleteIcon from '../../assets/images/delete_icon.png'
import './roles.css'

const font = "Outfit"

export default function DeleteRole({deleteUser, onDeleted}) {
  const user = null
  const [openDeleteRole, setDeleteRole] = useState(false)
  const [loading, setLoading] = useState(false)
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' })

  const handleDeleteInfo = () => {
    if (loading) return
    setLoading(true)
    axiosInstance.delete('/admin/delete-info', {
      data: { userId: deleteUser?.userId }
    })
    .then(() => {
      setDeleteRole(false)
      setSnackbar({ open: true, message: 'User deleted successfully', severity: 'success' })
      onDeleted?.()
    })
    .catch(() => {
      setSnackbar({ open: true, message: 'Error while deleting', severity: 'error' })
    })
    .finally(() => setLoading(false))
  }

  return (
    <div>
      <Dialog
        open={openDeleteRole}
        onClose={() => setDeleteRole(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: { borderRadius: "16px", p: 1 }
        }}
      >
        {/* Header */}
        <DialogTitle sx={{ textAlign: "center", pb: 0 }}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
            <Avatar sx={{ bgcolor: "#fff3f3", width: 56, height: 56 }}>
              <WarningAmberRoundedIcon sx={{ color: "#d32028", fontSize: 32 }} />
            </Avatar>
            <Typography sx={{ fontFamily: font, fontWeight: 700, fontSize: "18px", color: "#1a1a1a" }}>
              Delete User
            </Typography>
            <Typography sx={{ fontFamily: font, fontSize: "13px", color: "#888", fontWeight: 400 }}>
              This action cannot be undone.
            </Typography>
          </Box>
        </DialogTitle>

        {/* User info card */}
        <DialogContent sx={{ mt: 2, px: 3 }}>
          <Box
            sx={{
              backgroundColor: "#f8f9fa",
              borderRadius: "12px",
              p: 2,
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Avatar sx={{ bgcolor: "#ffe8e9", color: "#d32028", width: 44, height: 44 }}>
              <PersonOutlineRoundedIcon />
            </Avatar>
            <Box>
              <Typography sx={{ fontFamily: font, fontWeight: 600, fontSize: "15px", color: "#1a1a1a" }}>
                {deleteUser?.name}
              </Typography>
              <Typography sx={{ fontFamily: font, fontSize: "13px", color: "#626872" }}>
                {deleteUser?.emailId}
              </Typography>
              <Typography sx={{ fontFamily: font, fontSize: "13px", color: "#626872" }}>
                {deleteUser?.mobile}
              </Typography>
            </Box>
          </Box>
        </DialogContent>

        <Divider sx={{ mx: 3 }} />

        {/* Actions */}
        <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => setDeleteRole(false)}
            sx={{
              textTransform: "none",
              fontFamily: font,
              fontWeight: 500,
              borderRadius: "8px",
              borderColor: "#ddd",
              color: "#626872",
              "&:hover": { borderColor: "#bbb", backgroundColor: "#f5f5f5" }
            }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={handleDeleteInfo}
            disabled={loading}
            sx={{
              textTransform: "none",
              fontFamily: font,
              fontWeight: 600,
              borderRadius: "8px",
              backgroundColor: "#d32028",
              "&:hover": { backgroundColor: "#b81c22" },
              "&.Mui-disabled": { backgroundColor: "#e57373", color: "#fff" }
            }}
          >
            {loading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      <img
        onClick={() => setDeleteRole(true)}
        style={{ width: '16px', height: '16px', cursor: 'pointer' }}
        src={deleteIcon}
        alt=""
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar(s => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar(s => ({ ...s, open: false }))}
          severity={snackbar.severity}
          variant="filled"
          sx={{ fontFamily: font, "& .MuiAlert-message": { fontFamily: font } }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  )
}
